var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g(_vm._b({staticClass:"block px-4 py-3 text-gray-700 cursor-pointer hover:bg-grey-20"},'li',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }